<template>
  <div class="container-alert">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="状态看板 / Painel de Status" name="1">
        <template slot="label">
          <div class="tabs-title">
            <div>状态看板</div>
            <div>Painel de Status</div>
          </div>
        </template>
        <div v-if="activeName === '1'">
          <status-board
            :key="cmpKey" ref="statusBoard"
            :expire-warn-days="expireDays" @jump="handleJump"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="IE 信息管理 / Gestão de IE" name="2">
        <template slot="label">
          <div class="tabs-title">
            <div>IE 信息管理</div>
            <div>Gestão de IE</div>
          </div>
        </template>
        <div v-if="activeName === '2'">
          <ie-management
            :key="cmpKey" ref="ieList" :expire-warn-days="expireDays"
            :state-list="stateList" :prefilter-status="pendingIeStatus"
            @checked="handleBoardRefresh"
          />
        </div>
      </el-tab-pane>
      <!-- lazy：首次切到该页签时才渲染内容。否则内容在隐藏状态下挂载，
           el-tabs 会把 active-bar 宽度测量成 0，导致初始没有下划线 -->
      <el-tab-pane label="告警配置 / Configuração de Alertas" name="3" lazy>
        <template slot="label">
          <div class="tabs-title">
            <div>告警配置</div>
            <div>Configuração de Alertas</div>
          </div>
        </template>
        <div v-if="activeName === '3'">
          <alert-config :key="cmpKey" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="变更日志 / Log de Alterações" name="4">
        <template slot="label">
          <div class="tabs-title">
            <div>变更日志</div>
            <div>Log de Alterações</div>
          </div>
        </template>
        <div v-if="activeName === '4'">
          <change-log :key="cmpKey" :state-list="stateList" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="告警日志 / Log de Alertas" name="5">
        <template slot="label">
          <div class="tabs-title">
            <div>告警日志</div>
            <div>Log de Alertas</div>
          </div>
        </template>
        <div v-if="activeName === '5'">
          <alert-log :key="cmpKey" :state-list="stateList" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import StatusBoard from './cmp/StatusBoard';
import IeManagement from './cmp/IeManagement';
import AlertConfig from './cmp/AlertConfig';
import ChangeLog from './cmp/ChangeLog';
import AlertLog from './cmp/AlertLog';
import { getLgAreaListData } from '@/api/orderApi';

// 子模块 key → 页签 name
const MODULE_TAB = {
  'ie-list': '2',
  'alert-config': '3',
  'change-log': '4',
  'alert-log': '5'
};

export default {
  name: 'StatusMonitoringAndWarning',
  components: { StatusBoard, IeManagement, AlertConfig, ChangeLog, AlertLog },
  data() {
    return {
      activeName: '1',
      // 到期提醒提前天数：告警配置修改后同步给状态看板与 IE 列表（"即将过期"口径）
      expireDays: 0,
      stateList: [],
      cmpKey: new Date().getTime(),
      // 看板页签尚未渲染（懒加载）时，先记下「待刷新」，切到看板时补刷 KPI
      boardNeedRefresh: false,
      // 看板 KPI 联动到 IE 列表的预筛状态：仅用于组件首次挂载时带条件查询，避免重复请求
      pendingIeStatus: null
    };
  },
  created() {
    this.getAddress();
  },
  methods: {
    // 州
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
          this.cmpKey = new Date().getTime();
        }
      });
    },
    /** 切换页签：切回看板时若有待刷新标记（IE 管理刚做过全部检查），补刷一次 KPI */
    handleClick(tab) {
      const name = tab && (tab.name || tab.paneName);
      if (name === '1' && this.boardNeedRefresh) {
        this.boardNeedRefresh = false;
        this.$nextTick(() => this.refreshBoard());
      }
    },
    /** IE 管理「全部检查」完成：同步刷新状态看板的检查时间与告警计数 */
    handleBoardRefresh() {
      this.refreshBoard();
    },
    /** 刷新看板（检查时间 / 各州状态 / 异常清单 / 时间线）：已渲染则直接刷新，否则打标记等切页时补刷 */
    refreshBoard() {
      const board = this.$refs.statusBoard;
      if (board && board.refreshBoard) {
        board.refreshBoard();
        return;
      }
      this.boardNeedRefresh = true;
    },
    /** 看板内的联动跳转（KPI 卡片 / 查看全部 / 新增 IE 监控） */
    handleJump(payload = {}) {
      // 每次跳转先清空，避免上一次的预筛状态残留到本次挂载
      this.pendingIeStatus = null;
      const tab = MODULE_TAB[payload.module];
      // 切换前 IE 列表是否已挂载：未挂载则由 prop 带预筛条件查一次，挂载后直接调方法（各只发一次请求）
      const ieMounted = !!this.$refs.ieList;
      if (payload.module === 'ie-list' && payload.status && !ieMounted) {
        this.pendingIeStatus = payload.status;
      }
      if (tab) this.activeName = tab;
      this.$nextTick(() => {
        // KPI ①②：跳转 IE 列表并按主体状态预筛（提示由列表页给出，避免重复 toast）
        if (payload.module === 'ie-list' && payload.status && ieMounted && this.$refs.ieList) {
          this.$refs.ieList.prefilter(payload.status);
          return;
        }
        // if (payload.tip) this.$message.info(payload.tip);
      });
    }
  }
};
</script>
<style scoped lang="scss">
.container-alert {
  margin: -18px -20px -20px;
  min-height: calc(100vh - 100px);

  .tabs-title {
    padding: 10px 20px;

    div {
      line-height: 20px;
    }
  }
  .is-active .tabs-title {
    background: #fff;
  }
  /* 只作用于本页顶层的 el-tabs，避免穿透到子页面内部的 el-tabs（如告警配置的子页签） */
  > .el-tabs {
    ::v-deep .el-tabs__item {
      padding: 0;
      height: auto;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      height: 2px;
      background-color: #e7f2f1;
    }
    ::v-deep .el-tabs__content {
      padding: 0 20px;
    }
  }
}
</style>
